import React from 'react'
import styled from 'styled-components'
import Heading from '../../../../components/Heading'
import Text from '../../../../components/Text'
import WhatsAppLink from '../../../../components/WhatsAppLink'
import BankAccount from '../BankAccount'
import PayU from '../PayU'
import { spacing } from '../../../../tokens'

interface Props {
  typeOfPlan: string
  amountPaid?: string
}

function TypesOfPayment({ typeOfPlan, amountPaid }: Props) {
  return typeOfPlan === '' ? (
    <Heading size={3}>
      Por favor escríbenos a{' '}
      <strong>
        <a href="mailto:l.gomez@alau.org">l.gomez@alau.org</a>
      </strong>{' '}
      y uno de nuestros asesores educativos se pondrá en contacto en seguida.
    </Heading>
  ) : (
    <>
      <PayU typeOfPlan={typeOfPlan} />
      <Heading size={3}>
        <strong>Pago con despósito o transferencia</strong>
      </Heading>
      <Text>{amountPaid}</Text>
      <BankAccount
        bank={'bancolombia'}
        account={'#698-772193-13'}
        description={''}
      />
      <BankGeneralInfo>
        <Heading size={3}>Datos para el depósito ó transferencia</Heading>
        <Text>Nombre: alaU Colombia SAS</Text>
        <br />
        <Text>NIT: 901061936</Text>
        <br />
        <Text>Correo: info@alau.org</Text>
        <br />
        <Text>Confirma tu pago al WhatsApp: +593968098077</Text>
        <WhatsAppLink
          title="Confirma tu pago aquí"
          messageBody="Quiero confirmar el pago de mi suscripción"
        />
      </BankGeneralInfo>
    </>
  )
}

const BankGeneralInfo = styled.div`
  padding: ${spacing.small} 0px;
`
export default TypesOfPayment
